import { SET_BRANDS } from './brands.actions';

const initialState = [];

export const brandsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_BRANDS:
      return payload;
    default:
      return state;
  }
};
